import { ContactSubscriptionItem } from "@ua/web-sdk/lib/remote-data/preference-center"
import * as React from "react"

import { PreferenceOperator } from "./EmailPreferenceCenter"

type Props = { item: ContactSubscriptionItem } & PreferenceOperator

const ContactSubscriptionItem: React.FC<Props> = ({
  item,
  subscriptionLists,
  updateSubscriptions,
}) => {
  const scope = React.useMemo(() => item.scopes[0], [item])
  if (!scope)
    throw new Error("No scope available for contact subscripiton item")
  const subscribed = React.useMemo(() => {
    return Boolean(subscriptionLists[scope]?.[item.subscription_id])
  }, [subscriptionLists, item])
  const updateSubscription = React.useCallback(() => {
    updateSubscriptions({
      id: item.subscription_id,
      subscribed: !subscribed,
      scope,
    })
  }, [updateSubscriptions, scope, subscribed, item])
  return (
    <li>
      <label>
        <div className="list-checkbox">
          <input
            type="checkbox"
            checked={subscribed}
            onChange={updateSubscription}
          ></input>
        </div>
        <div className="list-information">
          {item.display.name}
          {item.display.description && (
            <p className="description">{item.display.description}</p>
          )}
        </div>
      </label>
    </li>
  )
}

export default ContactSubscriptionItem
